module.exports = __webpack_public_path__ + "img/p-icon7.982cc707.png";